/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useEffect, useState, useRef } from "react";
import { Input, Table, message, Select, DatePicker, Button } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

import {
  serialNum,
  capitalize,
  // checkNumbervalue,
  checkSpace,
  checkSpecialCharacter,
  commonSorterForTable,
  isValidAwb,
  getUserAndPremiseId,
} from "../../../utils";
import { getPremiseId } from "../../../utils/worker";
import urls from "../../../api/urls";
import API from "../../../api";
import { useRequestCancellation } from "../../../hooks/useRequestCancellation";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import nodeURL from "../../../api/nodeUrls";

import search_icon from "../../../assests/images/search-icon.svg";
import checkIcon from "../../../assests/images/SVG/check.svg";
import OrangeCheckIcon from "../../../assests/images/SVG/orange-check.svg";

import blue_bag_plus from "../../../assests/images/middleMile/blue-bag.svg";
import green_bag from "../../../assests/images/middleMile/green-bag.svg";
import white_bag from "../../../assests/images/middleMile/white-bag.svg";
import yellow_bag from "../../../assests/images/middleMile/yellow-bag.svg";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import "./style.scss";
import Heading from "../../../components/Heading";
import BagContentModal from "./bagContentModal";
import ScannedShipment from "../../../components/ScannedShipment";
import moment from "moment";
import { damageBagModal } from "../Bagging/damageBagModal";

const { GET_LCR_IN_SCAN_LIST_NEW, UPDATE_ALL_BAGS_NEW1, NEW_INSCAN } = urls;
const { NEW_INSCAN_BATCH } = nodeURL;
const { RangePicker } = DatePicker;

const LCRScanList = () => {
  const inputRef = useRef(null);

  // Request cancellation hook
  const { createNewRequest, isLatestRequest, cleanup } = useRequestCancellation();

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataSource, setdataSource] = useState(tableData);
  // const [inputSearchValue, setInputSearchValue] = useState("");
  const [totalScanned, setTotalScanned] = useState(0);
  const [totalShipments, setTotalShipments] = useState(0);
  const [totalBags, setTotalBags] = useState(0);
  const [totalBagsScanned, setTotalBagsScanned] = useState(0);

  const isFirstRender = useRef(true);

  const [pageSize, setPageSize] = useState(50);
  const [pageNum, setPageNum] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentStartDate, setCurrentStartDate] = useState(null);
  const [currentEndDate, setCurrentEndDate] = useState(null);
  const [showBagModal, setShowBagModal] = useState(false);
  const [currentBarCode, setCurrentBarCode] = useState(null);
  //const [showDamageBagModal, setShowDamageBagModal] = useState(false);

  const [filteredInfo, setFilteredInfo] = useState({});

  // Server-side filter states
  const [filterStatus, setFilterStatus] = useState("BOTH");
  const [filterBarcode, setFilterBarcode] = useState("");
  const [filterLcrId, setFilterLcrId] = useState("");

  const HUB_INSCANNED_LABEL = "HUB-IN-SCANNED";
  const white = "#fff";
  const blur = "#2E7FE1";
  const green = "#70C36E";
  const yello = "#D2DD3F";

  const colorDictionary = {
    "#fff": white_bag,
    "#2E7FE1": blue_bag_plus,
    "#70C36E": green_bag,
    "#D2DD3F": yellow_bag,
  };

  const [sortedInfo, setSortedInfo] = useState({});

  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
    setFilteredInfo(filters);

    // Handle pagination changes
    if (pagination) {
      const newPageNum = pagination.current ? pagination.current - 1 : 0; // Ant Design uses 1-based, API uses 0-based
      const newPageSize = pagination.pageSize || pageSize;

      if (newPageNum !== pageNum || newPageSize !== pageSize) {
        setPageNum(newPageNum);
        setPageSize(newPageSize);

        // Fetch new data with updated pagination
        if (currentStartDate && currentEndDate) {
          getLcrInscanList(currentStartDate, currentEndDate, newPageNum, newPageSize, filterStatus, filterBarcode, filterLcrId);
        } else {
          let todaysDate = moment(new Date(), "ddd MMM DD YYYY HH:mm:ss").format("DD/MM/YYYY");
          getLcrInscanList(todaysDate, todaysDate, newPageNum, newPageSize, filterStatus, filterBarcode, filterLcrId);
        }
      }
    }
  };

  useEffect(() => {
    let todaysDate = moment(new Date(), "ddd MMM DD YYYY HH:mm:ss").format(
      "DD/MM/YYYY"
    );
    setCurrentStartDate(todaysDate);
    setCurrentEndDate(todaysDate);
    getLcrInscanList(todaysDate, todaysDate, 0, pageSize);

    // Cleanup: Cancel any pending requests on unmount
    return () => {
      cleanup();
    };
  }, []);

  const closeModal = () => {
    setShowBagModal(false);
  };

  const getLcrInscanList = async (start, end, pageNumber, pageSizeParam, status = "BOTH", barcode = "", lcr = "") => {
    // Create new request and cancel previous one - this ensures only the latest request updates state
    const { signal, requestId } = createNewRequest("lcr-inscan-list");
    try {
      setLoading(true);

      const StartDate = moment(start, "DD/MM/YYYY").format("DD-MM-YYYY");
      const endDate = moment(end, "DD/MM/YYYY").format("DD-MM-YYYY");
      let response;

      let activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
      let userInfo = JSON.parse(localStorage.getItem("userId") || "{}");
      let hubId = activeHub?.hubId || userInfo?.userInfo?.premiseId;

      // Construct base query params
      // Adding filters for status, barcode, and LCR ID that were previously missing
      let queryParams = `?pageNumber=${pageNumber}&pageSize=${pageSizeParam}&hubId=${hubId}`;

      queryParams += `&status=${status || "BOTH"}`;
      if (barcode) queryParams += `&barcodeNo=${barcode}`;
      if (lcr) queryParams += `&lcrId=${lcr}`;

      if (start) {
        queryParams += `&fromDate=${StartDate}&toDate=${endDate}`;
      }

      response = await API.Api(
        GET_LCR_IN_SCAN_LIST_NEW + queryParams
      ).getWithPremiseIdHeader({ signal });

      // Only update state if this is the latest request
      if (isLatestRequest(requestId)) {
        if (response?.status) {
          setLoading(false);
          let data = response?.response?.data?.data;
          // Check if API returns total count
          const total = response?.response?.data?.count;
          setTotalRecords(total);
          setTableData(data || []);
          setdataSource(data || []);
          calculateTotals(data || []);
        } else {
          setLoading(false);
          // Check if it"s a cancelled request
          if (response?.response?.message?.includes("cancel") ||
            response?.response?.code === "ERR_CANCELED") {
            return;
          }
          message.error(response?.response?.data?.message || "Network error");
        }
      } else {
        // Request was superseded by a newer one, just update loading state
        setLoading(false);
      }
    } catch (error) {
      // Handle cancelled requests silently - don't show errors for cancelled requests
      if (error.name === "AbortError" ||
        error.name === "CanceledError" ||
        error.code === "ERR_CANCELED" ||
        error.message?.includes("cancel") ||
        axios.isCancel(error)) {
        // Only update loading if this was the latest request
        if (isLatestRequest(requestId)) {
          setLoading(false);
        }
        return;
      }

      // Only update state if this is the latest request
      if (isLatestRequest(requestId)) {
        message.error("Failed to fetch LCR inscan list");
        setLoading(false);
      } else {
        // Request was superseded, just update loading state
        setLoading(false);
      }
    }
  };

  function handleDateChange(params, p2) {
    // Defensive checks for null/undefined/empty
    if (!Array.isArray(params) || params.length < 2 || !Array.isArray(p2) || p2.length < 2) {
      message.error("Please select a valid date range.");
      return;
    }
    const startDate = params[0];
    const endDate = params[1];
    const diffInDays = endDate.diff(startDate, "days");
    if (diffInDays > 7) {
      message.error("You can only select a date range of 7 days or less!");
      return;
    }
    setCurrentStartDate(p2[0]);
    setCurrentEndDate(p2[1]);
    setPageNum(0); // Reset to first page when date changes
    getLcrInscanList(p2[0], p2[1], 0, pageSize, filterStatus, filterBarcode, filterLcrId);
  }

  const filterData = (param) => {
    const unique = [
      ...new Map(tableData?.map((item) => [item[param], item])).values(),
    ];

    const data = unique?.map((val) => {
      return {
        text: param == "vehicleNum" ? val[param] : capitalize(val[param]),
        value: val[param],
      };
    });
    return data;
  };

  function handleIdClick(val, barcode) {
    if (
      val?.isScanned && val?.isBag
    ) {
      setCurrentBarCode(barcode);
      setShowBagModal(true);
    }
  }

  const checkStatus = (val) => {
    return (val?.isScanned && val?.isBag);
  };

  const columns = [
    {
      title: "Sl No",
      align: "center",
      width: 10,
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: "LCR ID",
      dataIndex: "lcrNum",
      key: "lcrNum",
      width: 18,

      filters: filterData("lcrNum"),
      filteredValue: filteredInfo?.lcrNum || null,
      onFilter: (value, record) => record?.lcrNum === value,
      render: (text, record) => {
        return (
          <>
            <div
              // onClick={() => navigate("/lcr-packets-scan/" + text)}
              className="align-center"
              style={{ fontWeight: "500" }}
            >
              {text}
            </div>
          </>
        );
      },
    },
    {
      title: "Vehicle LCR Id",
      dataIndex: "vehicleLcrId",
      key: "vehicleLcrId",
      width: 18,
    },
    {
      title: "Trip ID",
      dataIndex: "tripId",
      key: "tripId",
      width: 19,

      render: (text) => <div className="align-center">{text}</div>,
    },
    {
      title: "Bag ID/ Individul shipment",
      dataIndex: "barcode",
      key: "barcode",
      width: 25,

      render: (text, val) => {
        return (
          <div
            // onClick={() => navigate("/lcr-packets-scan/" + text)}
            className="align-center"
          >
            <span
              className={checkStatus(val) ? "mr-1 pointer" : "mr-1"}
              style={{
                color: checkStatus(val) ? "#4394d3" : "black",
              }}
              onClick={() => handleIdClick(val, text)}
            >
              {text}
            </span>
            {val?.isBag ? (
              <img
                src={colorDictionary[val?.color]}
                style={{ width: "10px" }}
              />
            ) : null}
            {val?.isScanned && val?.isShipment ? (
              <img src={checkIcon} className="ml-1" />
            ) : val?.isScanned && val?.isBag ? (
              <img
                src={
                  val?.shipmentNum == val?.scanCount
                    ? checkIcon
                    : OrangeCheckIcon
                }
                className="ml-1"
              />
            ) : null}
          </div>
        );
      },
    },

    {
      title: "Date",
      dataIndex: "fromDate",
      key: "fromDate",
      width: 15,

      sortOrder: sortedInfo.columnKey === "fromDate" ? sortedInfo.order : null,
      sorter: (a, b) => commonSorterForTable(a, b, "fromDate"),
      ellipsis: true,
      render: (text) => (
        <div style={{ width: "100px" }}>
          {text?.split(" ")[0]?.split("-")?.reverse()?.join("-")}
        </div>
      ),
    },
    {
      title: "Mode",
      width: 15,

      dataIndex: "travelBy",
      key: "travelBy",
      sortOrder: sortedInfo.columnKey === "travelBy" ? sortedInfo.order : null,
      sorter: (a, b) => commonSorterForTable(a, b, "travelBy"),
      ellipsis: true,
      render: (text) => <div>{capitalize(text)}</div>,
    },
    {
      title: "No of shipments",
      width: 16,
      dataIndex: "shipmentNum",
      key: "shipmentNum",
      render: (text) => <div>{text === 0 ? "------" : text}</div>,
    },

    {
      title: "Scanned shipments",
      width: 25,

      dataIndex: "scanCount",
      key: "scanCount",
      render: (text) => <div>{text ? text : "---"}</div>,
    },
    // {
    //   title: "Serivce Type",
    //   dataIndex: "service",
    //   render: (text) => <div>{text ? text : "---"}</div>,
    // },
    {
      title: "From Hub",
      width: 25,

      dataIndex: "fromHub",
      key: "fromHub",
      sortOrder: sortedInfo.columnKey === "fromHub" ? sortedInfo.order : null,
      sorter: (a, b) => commonSorterForTable(a, b, "fromHub"),
      ellipsis: true,
      filteredValue: filteredInfo.fromHub || null,
      filters: filterData("fromHub"),
      onFilter: (value, record) => record?.fromHub?.startsWith(value),
      filterSearch: false,
      render: (text) => <div>{capitalize(text)}</div>,
    },

    // {
    //   title: "Destination Hub",
    //   width: 20,

    //   dataIndex: "destinationHub",
    //   key: "destinationHub",
    //   filterSearch: false,
    //   sortOrder:
    //     sortedInfo.columnKey === "destinationHub" ? sortedInfo.order : null,
    //   sorter: (a, b) => commonSorterForTable(a, b, "destinationHub"),
    //   ellipsis: true,
    //   filteredValue: filteredInfo.destinationHub || null,
    //   filters: filterData("destinationHub"),
    //   onFilter: (value, record) => record?.destinationHub?.startsWith(value),
    //   render: (text) => <div>{capitalize(text) || "-------"}</div>,
    // },
    {
      title: "Vehicle/Flight No",
      dataIndex: "vehicleNum",
      width: 22,

      key: "vehicleNum",
      sortOrder:
        sortedInfo.columnKey === "vehicleNum" ? sortedInfo.order : null,
      sorter: (a, b) => commonSorterForTable(a, b, "vehicleNum"),
      ellipsis: true,
      filters: filterData("vehicleNum"),
      filterSearch: false,
      filteredValue: filteredInfo?.vehicleNum || null,
      onFilter: (value, record) => record?.vehicleNum?.startsWith(value),
    },
  ];



  //--Barcode Scanner--//
  let barcode = "";
  let interval;
  const handleKeyDown = (event) => {
    if (interval) clearInterval(interval);
    if (event.code == "Enter") {
      if (barcode) handleScan(barcode);
      barcode = "";
      return;
    }
    if (event.key != "Shift") barcode += event.key;
    interval = setInterval(() => (barcode = ""), 20);
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    // cleanup this component
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [tableData]);

  // Helper function to get deviceId
  const getDeviceId = () => {
    let deviceId = localStorage.getItem("device_id");
    if (!deviceId) {
      deviceId = crypto.randomUUID();
      localStorage.setItem("device_id", deviceId);
    }
    return deviceId;
  };

  const handleScan = async (id) => {
    // Create new request and cancel previous one - this ensures only the latest scan request updates state
    const { signal, requestId } = createNewRequest("barcode-scan");

    try {
      // Split comma-separated barcode values into an array
      const barcodeNumbers = id
        ?.split(",")
        ?.map((barcode) => barcode?.trim())
        ?.filter((barcode) => barcode?.length > 0);

      if (!barcodeNumbers || barcodeNumbers.length === 0) {
        message.error("Please provide valid barcode numbers");
        return;
      }

      setLoading(true);

      // Get user data
      const userData = JSON.parse(localStorage.getItem("userinfo"));
      const getUserInfo = getUserAndPremiseId();
      const userId = getUserInfo?.userId;

      let activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
      let userInfo = JSON.parse(localStorage.getItem("userId") || "{}");
      let currentPremiseId = activeHub?.hubId || userInfo?.userInfo?.premiseId;

      // Fallback to existing logic if simple retrieval fails, though active_hub approach is preferred
      if (!currentPremiseId) {
        const premiseIdObj = getPremiseId();
        currentPremiseId = premiseIdObj?.split("Bearer")[1];
      }

      const premiseId = currentPremiseId;
      const deviceId = getDeviceId();

      // Prepare request body
      const requestBody = {
        barcodeNumbers: barcodeNumbers,
        premiseId: parseInt(premiseId),
        userId: parseInt(userId),
      };

      // Make API call to batch endpoint
      const response = await axios.post(NEW_INSCAN_BATCH, requestBody, {
        headers: {
          "Content-Type": "application/json",
          "smcs-premise-id": premiseId,
          "user-id": userId.toString(),
          "device-id": deviceId,
          Authorization: "Bearer " + userData?.accessToken,
          "X-Request-ID": uuidv4(),
        },
        signal, // Add signal for request cancellation
      });

      // Only update state if this is the latest request
      if (isLatestRequest(requestId)) {
        if (response?.status === 200 || response?.status === 201) {
          setLoading(false);
          let data = response?.data;

          // Handle response - check if it"s a string or object
          let responseMessage = "";
          if (typeof data === "string") {
            responseMessage = data;
          } else if (data?.message) {
            responseMessage = data.message;
          } else if (data?.data) {
            responseMessage = data.data;
          }

          // Get successfully scanned barcodes from API response
          const successfulBarcodes = data?.details?.successful || [];
          const failedBarcodes = data?.details?.failed || [];
          const summary = data?.summary || {};

          // Update table data for successfully scanned barcodes that exist in the table
          let scanData = [...tableData];
          let scannedCount = 0;
          const foundInTable = [];
          const notFoundInTable = [];

          successfulBarcodes.forEach((successItem) => {
            const barcode = successItem?.barcodeNumber;
            const getCurrentIndex = scanData?.findIndex(
              (item) => String(item?.barcode) === String(barcode)
            );

            if (getCurrentIndex !== -1 && scanData[getCurrentIndex]) {
              if (!scanData[getCurrentIndex]?.isScanned) {
                scannedCount++;
              }
              scanData[getCurrentIndex].barcodeStatus = "HUB-IN-SCANNED";
              scanData[getCurrentIndex].isScanned = true;
              scanData[getCurrentIndex].scanCount =
                (scanData[getCurrentIndex]?.scanCount || 0) + 1;
              foundInTable.push(barcode);
            } else {
              notFoundInTable.push(barcode);
            }
          });

          setTableData(scanData);

          if (scannedCount > 0) {
            setTotalScanned(totalScanned + scannedCount);
          }

          // Show appropriate message based on API response and table data
          if (summary.successful > 0) {
            if (foundInTable.length > 0) {
              if (foundInTable.length === successfulBarcodes.length) {
                message.success(
                  responseMessage || `${foundInTable.length} barcode(s) scanned successfully`,
                  1
                );
              } else {
                message.warning(
                  `${foundInTable.length} of ${successfulBarcodes.length} scanned barcode(s) found in the list.`,
                  1
                );
              }
            } else if (notFoundInTable.length > 0) {
              // API scan was successful but barcodes not in table
              message.warning(
                responseMessage || `${summary.successful} barcode(s) scanned successfully, but not found in the current list.`,
                1
              );
            }
          }

          // Show error for failed scans
          if (summary.failed > 0) {
            message.error(
              `${summary.failed} barcode(s) failed to scan.`,
              1
            );
          }
        } else {
          setLoading(false);
          message.error("Network error");
        }
      }
    } catch (error) {
      // Handle cancelled requests silently
      if (error.name === "AbortError" ||
        error.name === "CanceledError" ||
        error.code === "ERR_CANCELED" ||
        error.message?.includes("cancel") ||
        axios.isCancel(error)) {
        return;
      }

      // Only update state if this is the latest request
      if (isLatestRequest(requestId)) {
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          "Failed to scan barcode";
        message.error(errorMessage);
        setLoading(false);
      }
    }
  };
  const calculateTotals = (filteredData) => {
    let totalShipsScanned = 0;
    let totalShips = 0;

    let totalBagList = filteredData?.filter((item) => item?.isBag);
    let totalBags = totalBagList?.length;
    let totalBagsScanned = totalBagList?.filter(
      (item) =>
        item?.isBag &&
        (item?.barcodeStatus === "HUB-IN-SCANNED" ||
          item?.barcodeStatus === "INSCANNED_AT_TRANSIT")
    )?.length;

    filteredData.forEach((item) => {
      if (item?.scanCount !== null) {
        totalShipsScanned += item?.scanCount;
      }
      if (item?.shipmentNum !== null && !isNaN(item?.shipmentNum)) {
        totalShips += item?.shipmentNum;
      }
    });
    setTotalShipments(totalShips);
    setTotalScanned(totalShipsScanned);
    setTotalBags(totalBags);
    setTotalBagsScanned(totalBagsScanned);
  };

  function handlePageChange(pagination, filters, sorter, extra) {
    if (extra.action === "filter") {
      const filteredData = extra.currentDataSource;
      calculateTotals(filteredData);
    }
    setFilteredInfo(filters);
  }

  const clearFilters = () => {
    setFilteredInfo({});
  };

  const handleDelete = (key, index) => {
    setFilteredInfo((prev) => {
      const updatedFilteredInfo = { ...prev };
      const currentValue = updatedFilteredInfo[key];

      if (Array.isArray(currentValue)) {
        updatedFilteredInfo[key] = currentValue.filter((_, i) => i !== index);
      } else {
        delete updatedFilteredInfo[key];
      }

      return { ...updatedFilteredInfo };
    });
  };
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const handler = setTimeout(() => {
      setPageNum(0);
      getLcrInscanList(currentStartDate, currentEndDate, 0, pageSize, filterStatus, filterBarcode, filterLcrId);
    }, 1000);
    return () => clearTimeout(handler);
  }, [filterBarcode, filterLcrId]);

  function handleSelect(params) {
    const val = params === "Scanned" ? "SCANNED" : params === "Unscanned" ? "UNSCANNED" : "BOTH";
    setFilterStatus(val);
    setPageNum(0);
    getLcrInscanList(currentStartDate, currentEndDate, 0, pageSize, val, filterBarcode, filterLcrId);
  }

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  return (
    <div className="p-2">
      <Heading
        title="LCR List"
        // buttonClick={() => setShowDamageBagModal(true)}
        //nextPageTitle={"DAMAGE BAG"}
        shipmentScanning={
          <>
            <ScannedShipment
              scannedData={totalBagsScanned}
              totalData={totalBags}
              type="bag"
            />
            <ScannedShipment
              scannedData={totalScanned}
              totalData={totalShipments}
            />
          </>
        }
      />
      <div className="consolidated-manifest-cntr">
        <div className="header" style={{ flexWrap: "wrap" }}>
          <div className="left">
            <Input
              placeholder="Enter Bag Id/AWB number(s) to scan (comma-separated)"
              bordered
              ref={inputRef}
              onPressEnter={(e) => {
                const value = e.target.value;
                const storedPattern = localStorage.getItem("regexPattern");
                if (value.length > 6) {
                  // Split by comma and validate each barcode if pattern exists
                  if (storedPattern) {
                    const cleanPattern = storedPattern?.replace(/^\/|\/$/g, "");
                    const regex = new RegExp(cleanPattern);
                    const barcodes = value.split(",").map(b => b.trim()).filter(b => b.length > 0);

                    // Validate each barcode individually
                    const invalidBarcodes = barcodes.filter(barcode => !regex.test(barcode));
                    if (invalidBarcodes.length > 0) {
                      message.destroy();
                      message.error("Invalid Bag Id/AWB number format");
                      return;
                    }
                  }
                  handleScan(value);
                } else {
                  message.error("Enter correct Bag Id/AWB number");
                }
              }}
              onKeyPress={(e) => {
                // Allow comma for comma-separated values, but block other special characters
                const forbiddenChars = /[@!$#%^&*=+()""";?.><]/;
                if (forbiddenChars.test(e.key)) {
                  e.preventDefault();
                }
              }}
              style={{
                borderRadius: "5px",
                height: "32px",
                width: "400px",
                margin: "15px 12px",
              }}
            // suffix={<img src={search_icon} />}
            />
          </div>
          <div className="right-filters" style={{ display: "flex", gap: "10px", alignItems: "start" }}>
            <Input
              placeholder=" Search Bag/Shipments number"
              value={filterBarcode}
              onChange={(e) => setFilterBarcode(e.target.value)}
              allowClear
              style={{
                width: "220px",
                borderRadius: "5px",
                height: "32px"
              }}
            />
            <Input
              placeholder="Search LCR Id"
              value={filterLcrId}
              onChange={(e) => setFilterLcrId(e.target.value)}
              allowClear
              style={{
                width: "220px",
                borderRadius: "5px",
                height: "32px"
              }}
            />
            <RangePicker
              disabledDate={(current) => disabledDate(current)}
              onChange={handleDateChange}
              format={"DD/MM/YYYY"}
              defaultValue={[moment(), moment()]}
              style={{ height: "32px", borderRadius: "5px", padding: "4px 11px", width: "250px", }}
            />

            <Select
              value={filterStatus === "SCANNED" ? "Scanned" : filterStatus === "UNSCANNED" ? "Unscanned" : "Both"}
              style={{
                width: "110px",
                height: "32px"
              }}
              placeholder="Status"
              onChange={handleSelect}
              options={[
                {
                  value: "Scanned",
                  label: "Scanned",
                },
                {
                  value: "Unscanned",
                  label: "Unscanned",
                },
                {
                  value: "Both",
                  label: "Both",
                },
              ]}
            />
          </div>
        </div>
        <div style={{ padding: " 0 1.3rem", marginTop: "5px" }}>
          <div className="d-flex" style={{ flexWrap: "wrap" }}>
            {Object.entries(filteredInfo).flatMap(([key, value]) =>
              Array.isArray(value) ? (
                value.map((item, index) => (
                  <div
                    key={`${key}_${index}`}
                    style={{
                      background: "rgb(226 226 226)",
                      // border: "2px solid",
                      borderRadius: "10px",
                      margin: "4px",
                      padding: "7px",
                      fontSize: "11px",
                    }}
                  >
                    {item !== null
                      ? key === "vehicleNum"
                        ? item
                        : capitalize(item)
                      : null}
                    <CloseCircleOutlined
                      style={{ margin: "0 5px" }}
                      onClick={() => handleDelete(key, index)}
                    />
                  </div>
                ))
              ) : value !== null ? (
                <div key={key}>
                  {value}
                  <button onClick={() => handleDelete(key)}>Delete</button>
                </div>
              ) : null
            )}
          </div>
          {Object.keys(filteredInfo)?.length !== 0 && (
            <Button onClick={clearFilters} className="cancel-btn mt-1 mb-1">
              Clear filters
            </Button>
          )}
        </div>
        <Table
          columns={columns}
          // className="lcr-inscan-container table-head-sticky"
          // scroll={{
          //   x: 500,
          // }}
          scroll={{
            x: 1500,
            y: 300,
          }}
          dataSource={[
            // eslint-disable-next-line no-unsafe-optional-chaining
            ...tableData?.sort(function (a, b) {
              return a?.isScanned ? 1 : b?.isScanned ? -1 : 0;
            }),
          ]}
          // scroll={{ x: 1300 }}
          // scroll={{ x: 1300 }}
          pagination={{
            current: pageNum + 1, // Ant Design uses 1-based pagination
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            pageSizeOptions: ["20", "50", "100", "200"],
          }}
          onChange={handleChange}
          loading={{
            indicator: (
              <img
                src={Smcs_Loader}
                style={{ height: "100px", width: "100px" }}
              />
            ),
            spinning: loading,
          }}
        />
      </div>
      {/* {damageBagModal(showDamageBagModal, setShowDamageBagModal)} */}
      {showBagModal && (
        <BagContentModal
          currentBarcode={currentBarCode}
          showModal={showBagModal}
          modalClose={closeModal}
        />
      )}
    </div>
  );
};

export default LCRScanList;
